import { Box, Badge, IconButton, Avatar } from "@mui/material";
import { useAuthStore } from "hooks/useAuthStore";
import { ChangeEvent } from "react";
import { IconContext } from "react-icons";
import { RiImageAddLine } from "react-icons/ri";

export const ImageUser = () => {
  const { urlPhoto, startChangeImagenPerfil } = useAuthStore();
  const handleChangeProfilePhoto = (e: ChangeEvent<HTMLInputElement>) => {
    let formData = new FormData();
    formData.append("imagen", e.target.files![0]);
    formData.append("_method", "PUT");
    startChangeImagenPerfil(formData);
  };

  return (
    <Box className="flex justify-center items-center">
      <Badge
        overlap="circular"
        badgeContent={
          <IconButton color="primary" component="label">
            <input
              hidden
              accept="image/*"
              type="file"
              onChange={handleChangeProfilePhoto}
            />
            <Avatar sx={{ backgroundColor: "white" }}>
              <IconContext.Provider value={{ className: "text-[red]" }}>
                <RiImageAddLine />
              </IconContext.Provider>
            </Avatar>
          </IconButton>
        }
      >
        <Avatar
          sx={{
            width: "150px",
            height: "150px",
            marginBottom: "10px",
          }}
          src={urlPhoto}
        />
      </Badge>
    </Box>
  );
};
